// this loads E-v1 once for the entire app
let evLoaded = false

export default {
    methods: {
        loadWistiaVideo(options = {}) {
            if (!evLoaded) {
                this.loadJS('https://fast.wistia.com/assets/external/E-v1.js')
                evLoaded = true
            }

            this.loadJS(
                `https://fast.wistia.com/embed/medias/${this.video.id}.jsonp`,
                this.video.id,
                options
            )
        },
        loadJS(url, id, options = {}) {
            const { disableAutoPause } = options

            const script = document.createElement('script')
            script.async = true
            script.src = url
            document.head.appendChild(script)
            if (!id) return
            script.onload = () => {
                // _wq (wistia queue): API used by Wistia to queue actions, is a plain JS array
                window._wq = window._wq || []
                window._wq.push({
                    id,
                    onReady: (video) => {
                        const pauseSelf = (playingVideoId) => {
                            // don't pause if the triggering video was this video
                            if (disableAutoPause || playingVideoId === id) return
                            video.pause()
                        }
                        const emitPause = () => {
                            this.$uiEvents.$emit('videoStarted', id)
                        }
                        video.bind('play', emitPause)
                        this.$uiEvents.$on('videoStarted', pauseSelf)
                        // clean-up for unmounting
                        video.bind('beforeremove', () => {
                            this.$uiEvents.$off('videoStarted', pauseSelf)
                            video.unbind('play', emitPause)
                            return video.unbind
                        })
                    },
                })
            }
        },
    },
}
